module.exports = __webpack_public_path__ + "img/ff01.7bd634f1.svg";